import { Card, CardContent } from "@/components/ui";
import { CameraPlus } from "@/components/shared/icons";
import { useRef } from "react";
import { makeFileFromPicker } from "@/lib/platform/index.web";
import type { MediaFile } from "./types";

const ACCEPTED_TYPES = "image/png, image/jpeg, video/mp4, video/quicktime";

export function MediaPreviewInput({
  onChange,
}: {
  onChange(mediaFile: MediaFile): void;
}) {
  const inputFileRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputFileRef.current?.click();
  };

  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.files?.[0];
    if (raw) {
      const file = makeFileFromPicker(raw);
      const uri = URL.createObjectURL(raw);
      const isVideo = raw.type.startsWith("video/");
      onChange({ file, uri, raw, isVideo });
    }
  };

  return (
    <Card variant="info" onClick={handleClick} className="aspect-square">
      <CardContent className="flex items-center justify-center p-0">
        <CameraPlus className="size-6 color-brand-primary" weight="fill" />
        <input
          accept={ACCEPTED_TYPES}
          type="file"
          ref={inputFileRef}
          hidden
          onChange={handleFile}
        />
      </CardContent>
    </Card>
  );
}
